import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Device } from '../constants/device';
import { TeamMemberContainer } from './TeamMemberContainer';
import { MainMembersContainer } from './MainMembersContainer';
import { TeamItemContainer } from './TeamItemContainer';
import { t } from '../../i18n';
import { Team } from '../model/Team';
import { StyledMenuLink } from './StyledMenuLink';
import { Colors } from '../constants/colors';
import { isPrerendering } from '../helpers/isPrerendering';

type TeamItemProps = {
  team: Team;
};

type ToggleButtonProps = {
  isOpen: boolean;
};

type CollapsibleContentProps = {
  isOpen: boolean;
  contentHeight: number;
};

export const OurTeam = (props: TeamItemProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [contentHeight, setContentHeight] = useState(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isPrerendering()) return;
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [contentRef.current?.scrollHeight]);

  const mainMembersCount = 6;
  const mainMembers = props.team.teamMembers.slice(0, mainMembersCount);
  const otherMembers = props.team.teamMembers.slice(mainMembersCount);

  return (
    <TeamItemContainer>
      <MainMembersContainer>
        {mainMembers.map((member, key) => (
          <TeamMemberContainer key={key} member={member} itemsPerRow={3} importPictures />
        ))}
      </MainMembersContainer>
      <CollapsibleContent isOpen={isOpen} contentHeight={contentHeight}>
        <MembersContainer ref={contentRef}>
          {otherMembers.map((member, key) => (
            <TeamMemberContainer key={key} member={member} itemsPerRow={4} importPictures />
          ))}
        </MembersContainer>
      </CollapsibleContent>
      <ToggleButton
        href={'#'}
        color={Colors.lighterGrey}
        isOpen={isOpen}
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
      >
        {isOpen ? `${t('teams.mildblue.showLess')} -` : `${t('teams.mildblue.title')} +`}
      </ToggleButton>
    </TeamItemContainer>
  );
};

const MembersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 60px;
  margin-top: 40px;

  ${Device.tablet} {
    gap: 30px;
  }
`;

const CollapsibleContent = styled.div<CollapsibleContentProps>`
  overflow: hidden;
  transition: height 0.5s ease;
  height: ${({ isOpen, contentHeight }) => (isOpen ? `${contentHeight + 50}px` : 0)};
`;

const ToggleButton = styled(StyledMenuLink)<ToggleButtonProps>`
  background: transparent;
  border: none;
  cursor: pointer;
  margin-top: 40px;
`;
